import TotalAmountButton from './total-amount-button';

export default TotalAmountButton;
